// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"37":"Investment","41":"IPTK","288":"Portfolio","316":"ContactUs","596":"404","619":"Program","883":"Insight","928":"R&D"}[chunkId] + "." + {"37":"00a88402","41":"6acdcf61","288":"f7ef6b43","316":"b0b87857","596":"3872ad52","619":"31c38440","883":"77aec93d","928":"751abc4f"}[chunkId] + ".js";
};